export default function PracticeRoundCompletePage({
  sessionResult,
  practiceMode,
  practiceTopic,
  continuePractice,
  finishPractice,
  loading,
  styles,
}) {
  if (loading) {
    return (
      <div style={styles.card}>
        <div style={styles.emptyBox}>
          Loading round results...
        </div>
      </div>
    );
  }

  if (!sessionResult) {
    return (
      <div style={styles.card}>
        <div style={styles.emptyBox}>
          No round result found.
        </div>

        <button
          style={styles.secondaryButton}
          onClick={finishPractice}
        >
          Back
        </button>
      </div>
    );
  }

  const total =
    sessionResult.question_count || 0;

  const correct =
    sessionResult.correct_count || 0;

  const incorrect =
    sessionResult.incorrect_count || 0;

  const accuracy =
    Number(
      sessionResult.accuracy_pct || 0
    );

  const isWrongQuestionMode =
    practiceMode === "wrong_review" ||
    practiceMode === "wrong_active";

  return (
    <div style={styles.card}>
      <div
        style={{
          textAlign: "center",
          padding: "40px 20px",
        }}
      >
        <div
          style={{
            fontSize: "42px",
            marginBottom: "12px",
          }}
        >
          🎉
        </div>

        <h2 style={styles.sectionTitle}>
          {isWrongQuestionMode
            ? "Wrong Question Review Complete"
            : "Practice Round Complete"}
        </h2>

        <div
          style={{
            marginTop: "10px",
            color: "#6b7280",
          }}
        >
          {practiceMode === "wrong_review"
            ? "You completed your scheduled Wrong Question Review."
            : practiceMode === "wrong_active"
            ? "You completed a Wrong Question Practice round."
            : practiceMode === "subject" &&
              practiceTopic
            ? `You completed a practice round for ${practiceTopic.topic_name}.`
            : "You completed this Smart Practice round."}
        </div>

        <div
          style={{
            marginTop: "26px",
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit, minmax(130px, 1fr))",
            gap: "12px",
          }}
        >
          <div style={styles.emptyBox}>
            <strong>Questions</strong>

            <div
              style={{
                marginTop: "6px",
                fontSize: "24px",
                fontWeight: "700",
              }}
            >
              {total}
            </div>
          </div>

          <div style={styles.emptyBox}>
            <strong>Correct</strong>

            <div
              style={{
                marginTop: "6px",
                fontSize: "24px",
                fontWeight: "700",
              }}
            >
              {correct}
            </div>
          </div>

          <div style={styles.emptyBox}>
            <strong>Incorrect</strong>

            <div
              style={{
                marginTop: "6px",
                fontSize: "24px",
                fontWeight: "700",
              }}
            >
              {incorrect}
            </div>
          </div>

          <div style={styles.emptyBox}>
            <strong>Accuracy</strong>

            <div
              style={{
                marginTop: "6px",
                fontSize: "24px",
                fontWeight: "700",
              }}
            >
              {Math.round(accuracy)}%
            </div>
          </div>
        </div>

        <div
          style={{
            marginTop: "28px",
            padding: "16px",
            border: "1px solid #dbeafe",
            borderRadius: "12px",
            backgroundColor: "#eff6ff",
            textAlign: "left",
          }}
        >
          <div
            style={{
              fontWeight: "700",
              marginBottom: "6px",
            }}
          >
            {isWrongQuestionMode
              ? "Review Complete"
              : "Next Round"}
          </div>

          <div
            style={{
              color: "#475569",
            }}
          >
            {isWrongQuestionMode
              ? "Your wrong-question progress and review schedule have been updated based on this round."
              : "Your next 10 questions will be recalculated from your latest performance, including weak questions, review priority, and difficulty fit."}
          </div>
        </div>

        <div
          style={{
            marginTop: "28px",
            display: "flex",
            gap: "12px",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <button
            style={styles.smallPrimaryButton}
            onClick={continuePractice}
          >
            {isWrongQuestionMode
              ? "Back to Wrong Questions"
              : practiceMode === "subject"
              ? "Continue This Topic"
              : "Continue Smart Practice"}
          </button>

          <button
            style={styles.secondaryButton}
            onClick={finishPractice}
          >
            Finish
          </button>
        </div>
      </div>
    </div>
  );
}